module.exports = __webpack_public_path__ + "static/media/preview.5414f920.png";